module.exports = __webpack_public_path__ + "static/media/samsung-aife-2021-remote-1.7017e18b.webp";